import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import styled from 'styled-components';
import { Loader } from 'react-loaders';

import BannerLayout from "../../layouts/banner";
import {
  Table, Row, Cell
} from '../../components/table';
import { getRequest } from '../../../../../api/ApiService';
import Auth from '../../../../../routes/Auth';
import { handleSelectChange } from '../../utils';

const SubmittedButton = styled.div`
  width: 97px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #55b4bc;
  border-radius: 2px;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  cursor: default;
`;

const NotSubmittedButton = styled.div`
  width: 97px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #ec5e59;
  border-radius: 2px;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ec5e59;
  cursor: default;
`;

class DesicionsNotSubmitted extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      result: {
        pd: false,
        pm: false,
        op: false,
        fn: false,
      },
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, rounds, performanceFeedbacksGame } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    getRequest(
      `${process.env.REACT_APP_API_URL}teams/`
    ).then(res => {
      const teams = res.body;
      const teamsDidNotSubmit = performanceFeedbacksGame.find(i => i.type === "Did not submit").teams;
      const insufficientCapital = performanceFeedbacksGame.find(i => i.type === "Insufficient capital");
      let teamsToShowIds = [];
      if (insufficientCapital) {
        const teamsInsufficientCapital = insufficientCapital.teams;
        teamsToShowIds = teamsDidNotSubmit.filter(teamDidNotSubmit => !teamsInsufficientCapital.includes(teamDidNotSubmit));
      } else {
        teamsToShowIds = teamsDidNotSubmit;
      }

      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      const gameId = Number(Auth.getGameId());

      getRequest(
        `${process.env.REACT_APP_API_URL}games/${gameId}/journal/?round_id=${roundId}&?team_id=${team_id}`,
      )
        .then(res => {
          const keys = {
            pd: 'submit_development',
            pm: 'submit_marketing',
            op: 'submit_operations',
            fn: 'submit_finance'
          };

          let result = {};
          let history = [
            ...res.body,
          ];

          history.sort((a, b) => {
            const dateA = new Date(a.requested_at);
            const dateB = new Date(b.requested_at);

            return dateB - dateA;
          });

          ['pd', 'pm', 'op', 'fn'].forEach(type => {
            result[type] = false;

            const obj = history.find(i => i.path === `/api/teams/${keys[type]}/`);
            if (obj && obj.response && typeof obj.response.success !== 'undefined') {
              result[type] = obj.response.success;
            }
          });

          this.setState({
            loaded: true,
            teamsToShow,
            selectedTeamId: Number(team_id),
            allTeamsCount: teams.length,
          })
        })
        .catch(err => { });
    })
      .catch(err => { });
  }

  render() {
    const { previousShownErrors } = this.props;
    const {
      result,
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
    } = this.state;

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit | Did Not Submit Decisions"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams did not post some or all of their decisions.`}
        previousShownErrors={previousShownErrors}
        paragraph1={(
          <Fragment>
            <b>Note:</b> There are some teams that did not post their decisions yet their decisions were still processed because they had sufficient capital.
          </Fragment>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Table>
            <Row background="#2a4169">
              <Cell color="#ffffff">Department</Cell>
              <Cell color="#ffffff">Submission Status</Cell>
            </Row>
            <Row background="rgba(0, 27, 43, 0.02)">
              <Cell color="rgba(0, 27, 59, 0.94)">
                Product Management
              </Cell>
              <Cell>
                {result.pd && (
                  <SubmittedButton>
                    Submitted
                  </SubmittedButton>
                )}
                {!result.pd && (
                  <NotSubmittedButton>
                    Not Submitted
                  </NotSubmittedButton>
                )}
              </Cell>
            </Row>
            <Row background="rgba(0, 27, 43, 0.02)">
              <Cell color="rgba(0, 27, 59, 0.94)">
                Product Marketing
              </Cell>
              <Cell>
                {result.pm && (
                  <SubmittedButton>
                    Submitted
                  </SubmittedButton>
                )}
                {!result.pm && (
                  <NotSubmittedButton>
                    Not Submitted
                  </NotSubmittedButton>
                )}
              </Cell>
            </Row>
            <Row background="rgba(0, 27, 43, 0.02)">
              <Cell color="rgba(0, 27, 59, 0.94)">
                Operations
              </Cell>
              <Cell>
                {result.op && (
                  <SubmittedButton>
                    Submitted
                  </SubmittedButton>
                )}
                {!result.op && (
                  <NotSubmittedButton>
                    Not Submitted
                  </NotSubmittedButton>
                )}
              </Cell>
            </Row>
            <Row background="rgba(0, 27, 43, 0.02)">
              <Cell color="rgba(0, 27, 59, 0.94)">
                Finance
              </Cell>
              <Cell>
                {result.fn && (
                  <SubmittedButton>
                    Submitted
                  </SubmittedButton>
                )}
                {!result.fn && (
                  <NotSubmittedButton>
                    Not Submitted
                  </NotSubmittedButton>
                )}
              </Cell>
            </Row>
          </Table>
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default DesicionsNotSubmitted;


// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/decisions-not-submitted.js